export enum SLTKInputType {
  FIXED_PRICE = 'FIXED_PRICE',
  FIXED_PERCENT = 'FIXED_PERCENT',
  TRAIL_AMOUNT = 'TRAIL_AMOUNT',
  TRAIL_PERCENT = 'TRAIL_PERCENT',
}
